 const currentDate = new Date().toISOString().split('T')[0]

 export default currentDate